import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            allFlagSettings: [],
            bought_suppressors: 0,
            bought_in_days: 0,
            sold_suppressors: 0,
            sold_in_days: 0,
        };
    },
    getters: {
        allFlagSettings: (state) => state.allFlagSettings,
    },
    actions: {
        async getAllFlagSettings({ commit }) {
            //fetch list of all quotes
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-flag-settings").then((data) => {
                    commit("setAllFlagSettings", data.data);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getFlagSettingById({ commit }, id) {
            //fetch quote by id
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-flag-setting-by-id/" + id).then((data) => {
                    if (data.data.result) {
                        commit("setQuoteInfo", data.data.result);
                    } else {
                        window.location.href = "/";
                    }
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async storeFlagSetting({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/store-flag-setting", request)
                    .then((data) => {
                        dispatch("getAllFlagSettings");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateFlagSetting({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-flag-setting", request)
                    .then((data) => {
                        dispatch("getAllFlagSettings");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
       
        
    },
    mutations: {
        setAllFlagSettings(state, data) {
            state.allFlagSettings = data.result;
            state.bought_suppressors = data.admin_bought_suppressors;
            state.bought_in_days = data.admin_bought_in_days;
            state.sold_suppressors = data.admin_sold_suppressors;
            state.sold_in_days = data.admin_sold_in_days;
        },
    },
};
